/* eslint-disable */
<template>
    <div>
        <BasicCard v-if="p_loading" v-bind:title="`Caricamento dati`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
            <div class="d-flex flex-row justify-space-between">
                <v-hover><v-chip 
                    slot-scope="{ hover }"
                    :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                    @click.stop="close" absolute top left>
                    <v-icon>keyboard_arrow_left</v-icon>back</v-chip>
                </v-hover>
                <span class="d-flex row-flex align-center" v-if="ops_report.length > 0">
                    Report in corso:
                    <v-autocomplete dense outlined
                        class="ml-2"
                        hide-details
                        :items="ops_report"
                        label="report in corso"
                        :item-text="item => item.value.op_type + ': ' + (item.value.code ? ' - nr. '+item.value.code+' - ' : '') + item.value.instrument_desc"
                        item-value="id"
                        @change="changeReport"
                        v-model="change_report.selected_report"
                    /></span>  
            </div>
            <BasicCard 
                :title="r_types[report.op_type].name">
                <div class="d-flex flex-column">
                    <v-form ref="reportRegistry" v-model="r_valid">
                    <RowComponent
                        :label="`codice ordine`"
                        :value="operation.order_nr">
                    </RowComponent>
                    <RowComponent
                        :label="`data ordine`"
                        :value="getFormattedDate(operation.order_date)">
                    </RowComponent>
                    <RowComponent
                        :label="`data intervento`"
                        :value="getFormattedDate(operation.op_date)">
                    </RowComponent>
                    <v-container class="mt-2 mb-0 pb-0">
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-text-field dense outlined
                                    v-if="!autogenerateCode()"
                                    label="codice report interno*" 
                                    v-model="report.code"
                                    :rules="[rules.mandatory, rules.nameRules]"/>
                                <span v-else>codice temporaneo: <i>{{report.code}}</i></span>
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <CalendarField
                                    :disabled="!isDateEditable()"
                                    v-model="report.report_date"
                                    label="data report*"
                                    :rules="[rules.mandatory]"
                                    :minDate="operation.op_date"
                                ></CalendarField>
                            </v-col>
                        </v-row>
                        <!--v-btn text @click="generateReportCode">genera codice</v-btn-->
                    
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-text-field dense outlined
                                label="Procedura (assegnato automaticamente)"
                                disabled
                                v-model="report.other_info.procedure_code">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <CalendarField dense outlined
                                    label="data ricevimento in sede"
                                    :maxDate="report.report_date"
                                    v-model="report.other_info.receiving_date"/>
                            </v-col>
                        </v-row>
                    </v-container>
                    </v-form>
                </div>
            </BasicCard>
            <BasicCard>
                <template v-slot:title>
                    <div class="d-flex full-width align-center" @click="c_expand.instrument=!c_expand.instrument">
                        <StatusIcon class="px-2" icon_color="white" :status="getStatusIcon(instrument, {op_type:report.op_type})" :key="instrument.updated"/>
                        <span class="full-width text-truncate">{{ instrument.name }}/{{ instrument.serno}} - {{ instrument.model }} - {{instrument.manufacturer}}</span>
                        <v-btn fab text small class="mx-3" @click.stop="editInstrument"><v-icon class="white--text">edit</v-icon></v-btn>
                    </div>
                </template>
                <template v-slot:action>
                    <span @click.stop="c_expand.instrument=!c_expand.instrument">
                        <v-icon class="suggestion white--text" v-if="c_expand.instrument">expand_less</v-icon>
                        <v-icon class="suggestion white--text" v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.instrument" class="d-flex flex-column">
                    <RowComponent
                        label="famiglia"
                        :value="families[instrument.family].label"
                    />
                    <RowComponent
                        label="numero seriale"
                        :value="instrument.serno"
                    />
                    <RowComponent
                        label="marca"
                        :value="instrument.manufacturer"
                    />
                    <RowComponent
                        label="modello"
                        :value="instrument.model"
                    />
                    <RowComponent
                        label="codice utente"
                        :value="instrument.name"
                    />
                    <RowComponent
                        label="versione software"
                        :value="instrument.sw_version"
                    />
                    <RowComponent
                        label="note"
                        :value="instrument.description"
                    />
                </div>
            </BasicCard>
            <BasicCard>
                <template v-slot:title>
                    <div class="d-flex flex-grow-1" @click="c_expand.client=!c_expand.client">
                        <StatusIcon icon_color="white" class="mx-2" :status="getStatusIcon(client)"/>{{ client.name }} - {{ location.name }}
                    </div>
                </template>
                <template v-slot:action>
                    <span @click="c_expand.client=!c_expand.client">
                        <v-icon class="suggestion white--text" v-if="c_expand.client">expand_less</v-icon>
                        <v-icon class="suggestion white--text" v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.client" class="d-flex flex-column">
                    <RowComponent
                        :value="client.name"
                        :hide_label=true> 
                        P.IVA: {{ client.piva }}
                    </RowComponent>
                    <RowComponent
                        v-bind:value="location.name"
                        v-bind:hide_label=true>
                        <div v-if="instrument.department_id">
                            <b>Reparto:</b> {{ location.departments[instrument.department_id].name }}
                        </div>
                        {{ location.address }} {{ location.addrNum }}<br/>
                        {{ location.zip }} {{ location.city }}<br/>
                        {{ location.country }}
                    </RowComponent>
                    <RowComponent
                        label="Luogo esecuzione:">
                        <v-checkbox
                            v-model="report.on_site_execution"
                            label="Sede cliente"
                            hide-details
                            class="pa-0 ma-0"
                            />
                    </RowComponent>
                    <RowComponent
                        hide_label="true"
                        v-if="!report.on_site_execution">
                        <div class="d-flex mt-2 mx-2">
                            <v-text-field dense outlined
                                label="indirizzo*"
                                v-model="report.address_execution.address"
                                required
                            ></v-text-field>   
                            <v-text-field dense outlined
                                class="ml-2"
                                label="n° civico*"
                                v-model="report.address_execution.addrNum"
                                required
                            ></v-text-field>   
                            <v-text-field dense outlined
                                class="ml-2"
                                label="CAP*"
                                v-model="report.address_execution.zip"
                                required
                            ></v-text-field>
                            <v-text-field dense outlined
                                class="ml-2"
                                label="città*"
                                v-model="report.address_execution.city"
                                required
                            ></v-text-field>
                        </div>
                    </RowComponent>
                </div>
            </BasicCard>
            <BasicCard>
                <template v-slot:title>
                    <div class="d-flex flex-grow-1" @click="c_expand.old_reports=!c_expand.old_reports">
                        Report precedenti: {{ old_list.length }}
                    </div>
                </template>
                <template v-slot:action>
                    <span @click.stop="c_expand.old_reports=!c_expand.old_reports">
                        <v-icon class="suggestion white--text" v-if="c_expand.old_reports">expand_less</v-icon>
                        <v-icon class="suggestion white--text" v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.old_reports" class="d-flex flex-column">
                <span v-for="rep of old_list" :key="rep.id" class="py-2">
                    <v-btn text fab small color="primary" @click.stop="openOldReport(rep.id)"><v-icon>visibility</v-icon></v-btn>
                    nr. <b>{{rep.value.code}}</b> del <b>{{rep.value.report_date | formatDateTS }}</b>, eseguito da <b>{{$store.state.users[rep.value.owner_id].name}}</b>
                </span>
                </div>
            </BasicCard>
            <ReportCustomData 
                :o_data="report.custom_data"
                :op_type="report.op_type"
                :c_type="'object'"
                :show_info="false"
                ref="custom_data"
                />
            <BasicCard 
                v-if="!report.ext_data.instrument.complete[report.op_type]" 
                :title="`Strumento non completo, la misura non può essere effettuata`">
            </BasicCard>
            <div v-else>
            <BasicCard v-if="change_master" :title="`Seleziona modello per misure`">
                
                <div class="d-flex pa-2 align-center justify-between full_width" v-if="old_reports.length>0">
                    <v-autocomplete dense outlined
                        class=""
                        :items="old_reports"
                        return-object
                        label="report precedenti"
                        :item-text="item => `nr. ${item.code} - ${getFormattedDate(item.report_date)}`"
                        v-model="old_to_clone"
                        hide-details
                        />
                    <v-btn class="ml-2" color="primary" @click.stop="cloneReport">clona</v-btn>
                </div>
                <v-divider></v-divider>
                <div class="d-flex flex-column pa-2">
                    <b class="d-flex subtitle-1" v-if="old_reports.length>0">Master</b>
                    <div class="d-flex flex-column py-2" v-for="(p_id, p_idx) of Object.keys(report.pl_reports)" :key="p_id">
                        <div class="d-flex">
                            <div class="d-flex flex-grow-1 flex-shrink-0 flex-column">
                                <div class="d-flex text-subtitle-2">Dispositivo {{p_idx+1}} - {{ families[platforms[p_id].i_data.family].label }}</div>
                                <InstrumentPlatformInfo class="d-flex"
                                    v-bind:o_data="platforms[p_id].i_data"
                                    :show_divider="false"/>
                            </div>
                            <v-autocomplete dense outlined
                                class="d-flex flex-shrink-1 flex-grow-0 ml-2 align-start justify-end"
                                :items="platforms[p_id].masters"
                                v-model="new_masters[p_id]"
                                label="master*"
                                return-object
                                @change="changePlatformMaster(p_id, new_masters[p_id])"
                                item-text="name"
                                :rules="[rules.mandatory]" 
                                />
                        </div>
                        <CategoryDesc class="pl-2" v-if="platforms[p_id].i_data.category" :category_id="platforms[p_id].i_data.category" />
                        <div v-else class="pl-2 text-subtitle-2">Set di prove non selezionato</div>
                        <v-alert
                            class="d-flex"
                            v-if="pl_master_change && pl_master_change[p_id] && pl_master_change[p_id].alert"
                            dense
                            type="warning"
                            >
                            <div class="font-weight-bold d-flex">Master non compatibile con il set di prove</div>
                            <div class="d-flex caption" v-for="mis of pl_master_change[p_id].mismatch" :key="mis._id">
                                <i>{{mis.label}}</i>: <span v-if="mis.reason=='value'">valore non inserito</span>
                                <span v-else-if="mis.reason=='trial_nr'">n° prove master {{mis.nr_value}}</span>
                            </div>
                        </v-alert>
                        <v-divider class="py-2" v-if="p_idx < report.pl_reports.length-1" />
                    </div>

                    
                </div>
                <div class="d-flex justify-end pa-2">
                    <v-btn v-if="report.status != 'new'" @click.stop="cancelUpdateMaster">annulla modifiche</v-btn>
                    <v-btn class="ml-2" color="primary" :disabled="!enable_measure" @click.stop="updateMaster">seleziona le masse di lavoro</v-btn>
                </div>
            </BasicCard>
            <div class="d-flex flex-column" v-if="!change_master && enable_measure">
                <div class="d-flex justify-space-between">
                    <v-checkbox label="salvataggio automatico misure" v-model="automaticSave"></v-checkbox>
                    <v-btn @click.stop="changeMaster"><v-icon small class="ma-1">refresh</v-icon>cambia master</v-btn>
                </div>
                <BasicCard v-for="(p_id, p_idx) of Object.keys(report.pl_reports)" :key="p_id" :title="`Dispositivo ${p_idx+1} - ${ families[platforms[p_id].i_data.family].label }`">
                    <template v-slot:action>
                        <v-btn class="suggestion white--text" @click.stop="openResetMeasureDialog(p_id)" text><v-icon small class="mr-1">delete_sweep</v-icon>reset misure</v-btn>
                    </template>
                    
                    <div class="d-flex flex-column" v-if="report.pl_reports[p_id] && report.pl_reports[p_id].blocks && report.pl_reports[p_id].blocks.length>0" :key="report.pl_reports[p_id]._id">
                        <div class="d-flex flex-column">
                            <div class="d-flex ma-2">
                                <InstrumentPlatformInfo 
                                    :key="report.ext_data.instrument._rev"
                                    class="d-flex flex-grow-1 flex-shrink-0 flex-column"
                                    v-bind:o_data="platforms[p_id].i_data"
                                    :show_divider="false"/>
                                <v-autocomplete dense outlined
                                    :key="report.pl_reports[p_id]._id+'_'+report.pl_reports[p_id].primariesConfirmed"
                                    v-if="!report.pl_reports[p_id].primariesConfirmed"
                                    class="d-flex flex-shrink-1 flex-grow-0 ml-2 align-start justify-end"
                                    :items="platforms[p_id].primaries"
                                    v-model="pl_master_primaries[p_id].primaries"
                                    label="masse di lavoro"
                                    small-chips
                                    :item-text="item => `${item.name}`"
                                    return-object
                                    multiple
                                    :rules="[rules.arrayRules, rules.mandatory]"
                                />
                            </div>
                            <div class="d-flex ma-2">
                                <div class="d-flex flex-row align-start full-width">
                                    <div class="d-flex py-2 font-italic">
                                        Masse di lavoro selezionate:
                                    </div>
                                    <div class="d-flex pl-4" >
                                        <div class="d-flex flex-column">
                                            <div class="d-flex align-start px-2 py-2 " v-for="primary in pl_master_primaries[p_id].primaries" :key="p_id+'_'+primary._id">
                                                <div class="d-flex flex-column justify-start ">
                                                    <div class="font-weight-bold"><span v-if="primary.name!=''">{{ primary.name }}<br/></span>{{ primary.serno}} - {{ primary.model }} - {{ primary.manufacturer}} * {{ pfamilies[primary.family].label }}</div>
                                                    <div class="caption font-italic" v-if="primary.primary_data">
                                                        cert. n°: <span class="font-weight-bold">{{primary.primary_data.certificate_nr}}</span>, emesso da <span class="font-weight-bold">{{primary.primary_data.certificate_authority}}</span> il <span class="font-weight-bold">{{primary.primary_data.emission | formatDateTS }}</span><br/>
                                                        scadenza: <span class="font-weight-bold">{{primary.primary_data.expire | formatDateTS }}</span><br/>
                                                        <span v-if="primary.primary_data.min_use && primary.primary_data.max_use && primary.primary_data.uom">range di funzionamento: <span class="font-weight-bold">{{primary.primary_data.min_use}}{{primary.primary_data.uom}} - {{primary.primary_data.max_use}}{{primary.primary_data.uom}}</span></span>
                                                    </div>
                                                </div>
                                                <v-checkbox
                                                v-if="primary.primary_data && primary.family =='pesiera' && report.op_type=='iso'"
                                                class="d-flex ma-0 py-0 pl-6 align-start"
                                                label="completo"
                                                hide-details
                                                v-model="primary.primary_data.complete"
                                                @change="changePrimaryComplete(primary)"
                                                :disabled="report.pl_reports[p_id].primariesConfirmed"
                                                ></v-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex ma-2" v-if="report.op_type == 'iso' || report.op_type=='iso_simple'">
                                <div class="d-flex flex-row">
                                    <div class="d-flex font-italic">
                                        Scegli la tolleranza da usare:
                                    </div>
                                    <div class="d-flex flex-row pl-4">
                                        <v-radio-group class="ma-0" hide-details v-model="pl_master_primaries[p_id].chosen_tolerance" :disabled="report.pl_reports[p_id].primariesConfirmed">
                                            <v-radio v-for="(d_tol,index) in platforms[p_id].i_data.tolerance" :key="index" :value="d_tol">
                                                <template v-slot:label>
                                                    <span class="d-flex font-weight-bold mr-3">{{ tol_dict[d_tol.t_type].text }}</span>
                                                    <div v-if="d_tol.t_type!='law'">
                                                        <div class="d-flex flex-column " v-if="d_tol.value == 'instrument'">
                                                            <div v-for="t_ins of d_tol.t_vals" :key="t_ins.test_type">
                                                            <span class="mr-1">{{tol_instr_type[t_ins.test_type]}} - {{t_ins.t_val | formatNumber }}</span><span v-if="t_ins.t_calc == 'perc'">%</span><span v-else>divisioni</span>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <span class="mr-1">{{d_tol.t_vals[0].t_val  | formatNumber }}</span><span v-if="d_tol.t_vals[0].t_calc == 'perc'">%</span><span v-else>divisioni</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </div>
                                </div>
                            </div>
                            <v-alert dense type="warning" v-if="checkPrimaryCompatibility(p_id)">
                                <div  class="font-weight-bold d-flex">Primario/i non adatto/i allo strumento in prova</div>
                            </v-alert>
                            <v-alert
                                v-if="!pl_master_primaries[p_id].primaries || pl_master_primaries[p_id].primaries.length == 0 || (report.op_type == 'iso' && pl_master_primaries[p_id].chosen_tolerance== null)"
                                dense
                                type="warning"
                                >
                                <div v-if="!pl_master_primaries[p_id].primaries || pl_master_primaries[p_id].primaries.length == 0" class="font-weight-bold d-flex">Selezionare almeno un primario</div>
                                <div v-if="(report.op_type == 'iso' || report.op_type == 'iso_simple') && pl_master_primaries[p_id].chosen_tolerance== null" class="font-weight-bold d-flex">Selezionare la tolleranza</div>
                            </v-alert>

                            <div class="d-flex ma-2 justify-end" :key="report.pl_reports[p_id]._id+'_'+report.pl_reports[p_id].primariesConfirmed" v-if="!report.pl_reports[p_id].primariesConfirmed">
                                <v-btn v-if="report.pl_reports[p_id].primaries && report.pl_reports[p_id].primaries.length > 0" @click.stop="primariesCancel(p_id)">annulla</v-btn>
                                <v-btn class="ml-2" color="primary" :disabled="!pl_master_primaries[p_id].primaries || pl_master_primaries[p_id].primaries.length == 0" @click.stop="confirmPrimaries(p_id)">procedi con le misure</v-btn>
                            </div>
                            <div class="d-flex ma-2 justify-end" v-else>
                                <v-btn @click.stop="primaryChange(p_id)">Cambia masse di lavoro</v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex pa-2 subtitle-2 font-weight-bold">Master:  {{ report.pl_reports[p_id].name }} - revisione: {{ report.pl_reports[p_id].master_rev }}</div>
                    <v-alert
                        dense
                        type="warning" 
                        dismissible 
                        v-model="instrument_changed_alert[p_id]">
                        <div class="font-weight-bold">Verificare la coerenza delle misure: strumento aggiornato!</div>
                    </v-alert>
                    <ConfirmDialog
                        v-if="instrument_changed_alert[p_id]"
                        v-bind:data="updated_instrument_confirm"
                        v-on:close_dialog="closeDialog"
                        v-on:confirm_result="onUpdatedInstrumentConfirm"
                        />
                    <v-expansion-panels class="d-flex" v-if="report.pl_reports[p_id].primariesConfirmed">
                        <v-expansion-panel
                            class="pa-0 ma-0"
                            v-for="(element, idx) in report.pl_reports[p_id].blocks"
                            :key="element.id" v-model="platforms[p_id].panels[idx]">
                            <v-expansion-panel-header color="expansion">
                                <template v-slot:default="{ open }">
                                    <v-row no-gutters>
                                        <v-col cols="10" class="text-uppercase pa-0 ma-0 font-weight-bold">{{ idx+1 }} - {{ element.label }}</v-col>
                                        <v-col
                                        cols="2"
                                        class="d-flex justify-end pr-2"
                                        >
                                        <v-fade-transition leave-absolute>
                                            
                                            <span
                                            v-if="open"
                                            key="0"
                                            >
                                            </span>
                                            <span
                                            v-else-if="report.pl_reports[p_id].blocks[idx].measures && report.pl_reports[p_id].blocks[idx].measures.result"
                                            key="1"
                                            >   
                                                <StatusIcon :status="report.pl_reports[p_id].blocks[idx].measures.result" :tooltip_text="block_tooltip[report.pl_reports[p_id].blocks[idx].measures.result]" />
                                            </span>
                                            <span
                                            v-else
                                            key="1"
                                            >   
                                                <StatusIcon status="missing" :tooltip_text="block_tooltip['missing']"/>
                                            </span>
                                        </v-fade-transition>
                                        </v-col>
                                    </v-row>
                                </template>
                                <div class="text-uppercase pa-0 ma-0 font-weight-bold">{{ idx+1 }} - {{ element.label }}</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="ma-0 pa-0">
                            <dynamiclink 
                                :key="report.ext_data.instrument._rev+'_'+element._id+''+ts_updated_block"
                                class="mb-2" 
                                type="layout"
                                v-on:updateMeasure="updateBlockMeasure"
                                @pretestResult="catchPretestResult"
                                :data="{'block': element, 'b_index': idx, 'instrument_data':platforms[p_id].i_data, 'p_idx': p_idx, 'p_id': p_id, 'm_static': report.pl_reports[p_id].static, primaries: report.pl_reports[p_id].primaries, selected_mode: report.pl_reports[p_id].selected_mode, common_data: report.pl_reports[p_id].common_data, invalidPrimaries: invalidPrimaries[p_id], current_tolerance: report.pl_reports[p_id].chosen_tolerance}" :preview="false">
                            </dynamiclink>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    </v-expansion-panels>
                </BasicCard>
                <BasicCard title="Osservazioni conclusive">
                    <div v-if="report.history && report.history.length>0">
                        <RowComponent
                            label="storico">
                                <div class="d-flex flex-column full-width"> 
                                <div v-for="h in report.history" :key="h.rev">
                                    <div class="font-weight-bold text-uppercase">revisione {{ h.rev }}</div>
                                    <div class="d-flex flex-column">
                                        <span class="d-flex"><span class="font-italic">eseguito il {{getFormattedDate(h.report_date)}}</span> - {{ h.remarks}}</span>
                                        <span class="d-flex"><span class="font-italic">riesaminato il {{getFormattedDate(h.review_date)}}</span> - {{ h.review_remarks}}</span>
                                    </div>
                                </div>
                                </div>
                        </RowComponent>
                    </div>
                    <div class="pa-4">
                        <v-alert
                            v-if="closureAlert == 'uncomplete' || closureAlert == 'failed'"
                            dense
                            type="warning"
                            >
                            <div class="d-flex flex-column" v-if="closureAlert == 'uncomplete'">
                                <div class="font-weight-bold">Report non completo</div>
                                <div>Una o più prove mancanti o non complete</div>
                            </div>
                            <div class="d-flex flex-column" v-if="closureAlert == 'failed'">
                                <div class="font-weight-bold">Report fallito</div>
                                <div>Una o più prove non superate</div>
                            </div>
                        </v-alert>
                        <v-textarea dense outlined
                            hide-details
                            v-model="report.remarks" 
                            rows="3" 
                            label="note" >
                        </v-textarea>
                    </div>
                </BasicCard>
                <div class="pa-4">
                    <v-alert
                        v-if="save_error"
                        dense
                        type="warning"
                        >
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold">Salvataggio fallito</div>
                            <div>Riprovare oppure segnalare il problema all'amministratore di sistema.</div>
                        </div>
                    </v-alert>
                </div>
            </div>
            <div class="ma-2 d-flex align-center flex-wrap justify-center my-4">
                <v-btn v-if="next_status.includes('completed')" :disabled="!save_complete" color="primary" @click.stop="saveExit('completed')">misure concluse</v-btn>
                <v-btn v-if="next_status.includes('measuring')" :disabled="!r_valid" text @click.stop="saveExit('measuring')">salva</v-btn>
                <v-btn v-if="next_status.includes('deleted') || !report.history || report.history.length==0" text @click.stop="closeWithAlert('deleted')">annulla report</v-btn>
                <v-btn v-if="next_status.includes('failed')" :disabled="!r_valid" text @click.stop="closeWithAlert('failed')">misure fallite</v-btn>
                <v-btn v-if="next_status.includes('completed_failed')" :disabled="!r_valid" text @click.stop="closeWithAlert('completed_failed')">misure fallite</v-btn>
            </div>
            </div>
            <InstrumentDialog
                ref="instrumentEdit"
                :org_id="computed_org"
                v-on:update_instrument="updateInstrument"
            />
            <BaseDialog 
                :max_width="`300`"
                :dialog="show_alert"
                title="Attenzione"
                v-on:close_dialog="close"
            >
                <p>
                    Il report non è più modificabile.
                </p>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn text v-on:click="close">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
            <BaseDialog 
                :max_width="`300`"
                :dialog="show_error"
                title="Attenzione"
                v-on:close_dialog="close">
                <p>
                    Si è presentato un errore inaspettato!
                </p>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn text v-on:click="close">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
            <BaseDialog 
                :max_width="`600`"
                :dialog="change_report.show"
                :title="'Cambia report'"
                v-on:close_dialog="change_report.show=false">
                <p>
                    Vuoi andare al report selezionato e salvare il report corrente?
                </p>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn color="primary" @click="goToReport">Procedi</v-btn>
                        <v-btn text @click="change_report.show=false">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
            
            <BaseDialog 
                :max_width="`500`"
                :dialog="show_close_alert"
                title="Attenzione"
                v-on:close_dialog="show_close_alert=false"
            >
                <p v-if="closing_status=='failed'">
                    Dopo la chiusura per misure fallite il report non sarà più modificabile.
                </p>
                <p v-if="closing_status=='deleted'">Dopo l'annullamento il report non sarà più disponibile.
                </p>
                <v-textarea dense outlined v-model="report.remarks" rows="3" :rules="[rules.mandatory, rules.nameRules]" label="note*">
                </v-textarea>
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn color="primary" v-on:click="saveExit(closing_status)">procedi</v-btn>
                        <v-btn text v-on:click="show_close_alert=false">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
            <ConfirmDialog
                v-bind:data="reset_measure_confirm"
                v-on:close_dialog="closeDialog"
                v-on:confirm_result="onResetMeasureConfirm"/>
            <ConfirmDialog
                v-bind:data="change_primaries_confirm"
                v-on:close_dialog="closeDialog"
                v-on:confirm_result="onChangePrimariesConfirm"/>
            
            <BaseDialog 
                :max_width="`80%`"
                :dialog="show_old_report.dialog"
                title="dettagli report"
                v-on:close_dialog="show_old_report.dialog=false"
            >
                <ReportDetails
                    :report_id="show_old_report.selected_report"
                    :show_action="false"
                    />
                <template v-slot:action>
                    <div class="d-flex align-center justify-center my-4">
                        <v-btn text v-on:click="show_old_report.dialog=false">Chiudi</v-btn>
                    </div>
                </template>
            </BaseDialog>
        </div>
    </div>
</template>

<script>
// import _ from 'lodash'
import { f_rules, formatDatefromTS, getObjStatus, checkMasterCategoryMatch  , uoms_conversion } from '../../utils/commonUtils'
import { getModel } from '../../utils/model'
import { isAdmin } from '../../utils/rolesManagement'
import { rStatusCanChange, report_status_transition} from "../../utils/statusManagement"
import { report_type, i_families, tolerance, block_status_tooltip, exempted, p_families } from "../../utils/common"
import { searchDesign } from "../../utils/dbUtility"
import {filterPrimaries} from "../../utils/report_utility"
import BasicCard from '../../components/utils/Basic_card.vue'
import BaseDialog from '../../components/dialogs/BaseDialog'
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import RowComponent from '../../components/utils/RowComponent.vue'
import StatusIcon from '../../components/utils/StatusIcon'
import dynamiclink from '../../components/utils/Block_Dynamic_link.vue'
import ReportCustomData from "./Report_utils/ReportCustomData"
import InstrumentPlatformInfo from "../instruments/Instrument_utils/Instrument_platform_info"
import InstrumentDialog from "../instruments/InstrumentDialog"
import CategoryDesc from "../instruments/CategoryDesc"
import ReportDetails from "./ReportDetails"
import Big from "big.js"

export default {
    components: {
        dynamiclink,
        BasicCard, 
        RowComponent, 
        ReportCustomData, 
        InstrumentPlatformInfo, 
        InstrumentDialog,
        ReportDetails,
        StatusIcon, 
        BaseDialog,
        ConfirmDialog,
        CategoryDesc
    },
    props: {
        report_id: {
            type: String,
            required: false,
            default: null
        },
        operation_id: {
            type: String,
            required: false,
            default: null
        },
        instrument_id: {
            type: String,
            required: false,
            default: null
        },
        op_type: {
            type: String,
            required: false,
            default: null
        },
        op_date: {
            type: String,
            required: false,
            default: "0"
        },
        back: {
            type: String,
            required: false,
            default: null
        }
    },
  
    data() {
        return {
            report: null,
            operation: null,
            instrument: null,
            client: null,
            location: null,
            p_loading: true,
            platforms: {},
            sel_master: null,
            enable_measure: false,
            change_master: true,
            c_expand: {
                instrument: false,
                client: false,
                old_reports: false
            },
            r_types: report_type,
            procedures: [],
            old_reports: [],
            old_to_clone: null,
            rules:f_rules,
            c_operation_id: null,
            c_instrument_id: null,
            c_op_type: null,
            show_alert: false,
            show_close_alert: false,
            show_error: false,
            closing_status: '',
            automaticSave: true,
            r_valid: false,
            tol_dict: {},
            invalidPrimaries: {},
            instrument_changed_alert: {},
            pl_master_change: {},
            pl_master_primaries: {},
            change_check: {
                instrument: false,
                master: false,
                client: false
            },
            change_primaries_confirm: {
                dialog: false,
                title: 'Modifica masse di lavoro ',
                message: "Procedere con la modifica delle masse di lavoro? Scegli se mantenere le misure precedenti o eliminarle",
                plat_id: null,
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "mantain", val: "mantieni misure"},
                    {key: "delete", val: "elimina misure"}
                ]
            },
            updated_instrument_confirm: {
                dialog: true,
                title: 'Strumento aggiornato ',
                message: "Attenzione, cliccando sul tasto 'mantieni misure' si può causare un blocco irreversibile del report nel caso in cui siano state fatte modifiche significative allo strumento oggetto di taratura. Se non siete sicuri delle modifiche apportate allo strumento cliccate sul tasto 'cancella misure'",
                plat_id: null,
                choices: [
                    {key: "cancel", val: "chiudi", mod: "success"},
                    ]
            },
            reset_measure_confirm: {
                dialog: false,
                title: 'Reset misure ',
                message: "Sei sicuro di voler eliminare le misure di tutte le prove del dispositivo selezionato?",
                plat_id: null,
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            change_master_confirm: {
                dialog: false,
                title: 'Cambio master ',
                message: "Sei sicuro di voler cambiare il master? Tutte le misure verrano eliminate e portate ai valori iniziali.",
                plat_id: null,
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            new_masters: {},
            ops_report: [],
            change_report: {
                selected_report: null,
                show: false
            },
            show_old_report: {
                selected_report: null,
                dialog: false
            },
            ts_updated_block: 0,
            save_complete: false,
            block_tooltip: block_status_tooltip,
            tol_instr_type: {},
            closureAlert: 'done',
            save_error: false,
            families: i_families,
            pfamilies: p_families
        }
    },
    async mounted() {
        this.save_error = false
        await this.loadReport()
        this.tol_instr_type = tolerance._instrument_label[this.instrument.family]
    },
    created(){
        this.debouncedSave = _.debounce(function(){
            //console.log('debouncedSave: automatic save', this.automaticSave)
            this.saveReport()
        },1000)
        this.debouncedComplete = _.debounce(function(){
            // console.log('debouncedComplete: ', this.save_complete)
            this.checkCompleteSave()
        },1000)
        this.tol_dict = _.keyBy(tolerance._type, t => t.id);
    },
    watch: {
        'report_id': {
            async handler() {
                await this.loadReport()
            }
        },
        'r_valid': {
            handler() {
                this.debouncedComplete()
            }
        }
    },
    computed: {
        computed_org() {
            let org_id = this.$store.state.user.org_id
            if (this.report.owner_id != this.$store.state.user._id && isAdmin(this.$store.state.user.roles)){
                org_id = this.$store.state.users[this.report.owner_id].org_id
            }
            return org_id
        },
        /*save_complete(){
            let valid = true
            for (let p_id of Object.keys(this.report.pl_reports)) {
                if (this.report.pl_reports[p_id] && this.report.pl_reports[p_id].primaries) {
                    let blocksInitialized = true
                    for (let block of this.report.pl_reports[p_id].blocks){
                        if(!block.measures) {
                            blocksInitialized = false
                        }
                    }
                    valid = valid && this.report.pl_reports[p_id].primaries.length > 0 && blocksInitialized
                } else {
                    valid = false
                }
                if (!valid) {
                    break
                }
            }

            return valid && this.r_valid
        }*/
        next_status() {
            return report_status_transition[this.report.op_type][this.report.status].next
        }
    },
    methods: {
        checkPrimaryCompatibility(plat_id){
            let instr_plat = null
            for(let platform of this.instrument.platforms){
                if(platform.id == plat_id){
                    instr_plat = platform
                    break
                }
            }
            if(!instr_plat){
                return false
            }
            if(exempted.includes(instr_plat.family)){
                return true
            }
            let primaries = this.pl_master_primaries[plat_id].primaries
            
            if(primaries && primaries.length > 0){
                let weights = primaries.filter((item) => {
                    if (item.family == "pesiera"){
                        return true
                    }
                })
                let scales = primaries.filter((item) => {
                    if (item.family == "bilancia nawi"){
                        return true
                    }
                })
                if (weights.length > 0){
                    let min = Big(0)
                    let maxSum = Big(0)
                    for(let primary of weights){
                        if (!primary.primary_data){
                            continue
                        }
                        let conv_factor = uoms_conversion[primary.primary_data.data.uom][instr_plat.uom]
                        let maxR = Big(primary.primary_data.data.weightTotal).times(conv_factor)
                        maxSum = maxSum.plus(maxR)
                        let minR = Big(primary.primary_data.data.min_weight).times(conv_factor)
                        if (minR.lt(min)){
                            min = minR
                        }
                    }
                    let minInstr = instr_plat.ranges[0].d
                    let maxInstr = instr_plat.ranges[instr_plat.ranges.length -1].max
                    if(instr_plat.uom == "kg" && Big(maxInstr).gte(1000)){
                        let reducedMax = Big(maxInstr).times(0.2)
                        if (min.minus(minInstr).gte(0)){
                            return true
                        } else if(maxSum.minus(reducedMax).lte(0)){
                            return true
                        } else {
                            return false
                        }
                    } else {
                        if (min.minus(minInstr).gte(0)){
                            return true
                        } else if(maxSum.minus(maxInstr).lt(0)){
                            return true
                        } else {
                            return false
                        }
                    }
                } else if (scales.length > 0){
                    let min = 1000
                    let max = 0
                    let tot_conv_factor = 1000000
                    for(let primary of scales){
                        for(let plat of primary.platforms){
                            let curr_conv = uoms_conversion[plat.uom][instr_plat.uom]
                            if (Big(curr_conv).lt(tot_conv_factor)){
                                tot_conv_factor = curr_conv
                            }
                            if (curr_conv == 1){
                                let minP = plat.ranges[0].d
                                let maxP = plat.ranges[plat.ranges.length -1].max
                                if(Big(minP).lt(min)){
                                    min = minP
                                }
                                if(Big(maxP).gt(max)){
                                    max = maxP
                                }
                            }
                        }
                    }
                    console.log("$$ stampa valori", min, max)
                    let minInstr = instr_plat.ranges[0].d
                    let maxInstr = instr_plat.ranges[instr_plat.ranges.length -1].max
                    if (Big(min).minus(minInstr).gt(0)){
                        return true
                    } else if (Big(max).minus(maxInstr).lte(0)){
                        return true
                    } else {
                        return false
                    }
                }
            } else {
                return false
            }
        },
        checkCompleteSave(){
            let valid = true
            this.closureAlert = 'done'
            for (let p_id of Object.keys(this.report.pl_reports)) {
                if (this.report.pl_reports[p_id] && this.report.pl_reports[p_id].primaries) {
                    let blocksInitialized = true
                    for (let block of this.report.pl_reports[p_id].blocks){
                        if(!block.measures) {
                            blocksInitialized = false
                            this.closureAlert = 'uncomplete'
                        } else {
                            switch(block.measures.result) {
                                case 'uncomplete':
                                    this.closureAlert = 'uncomplete'
                                    break
                                case 'done':
                                    this.closureAlert = this.closureAlert == 'dome '? 'done' : this.closureAlert
                                    break
                                case 'failed':
                                    this.closureAlert = (this.closureAlert == 'failed' || this.closureAlert == 'done') ? 'failed' : this.closureAlert
                                    break
                            }  
                        }
                    }
                    valid = valid && this.report.pl_reports[p_id].primaries.length > 0 && blocksInitialized
                } else {
                    valid = false
                }
                if (!valid) {
                    break
                }
            }

            this.save_complete = valid && this.r_valid
        },
        async loadReport() {
            this.p_loading = true
            let report_exists = false
            let block_edit = false
            
            // console.log("report_id", this.report_id)
            if (!!this.report_id) {
                this.report = await this.$store.state.$pouch.get('reports', this.report_id)
                // console.log("report", this.report)
                if (!!this.report) {
                    report_exists = true
                    this.c_operation_id = this.report.operation_id
                    this.c_instrument_id = this.report.instrument_id
                    this.c_op_type = this.report.op_type
                    // console.log("**** report complete",this.report.complete)
                    if (this.report.complete ) {
                        // redirect to report details (ALL TASKS ARE DONE)initPlatformsData
                        // OR DIRECT MODIFY
                        this.show_alert = true
                        return
                    } else {
                        switch(this.report.status) {
                            case 'new':
                                break;
                            case 'measuring':
                                // console.log(this.report.owner_id, this.$store.state.user._id)
                                if (this.report.owner_id != this.$store.state.user._id) {
                                    // check permission
                                    // block_edit = true
                                }
                                break
                            case 'completed':
                                // check permission
                                block_edit= true
                                break
                            case 'deleted':
                                // check permission
                                block_edit= false
                                break
                            
                            default:
                                block_edit= true
                        } 
                    }
                }
            } else {
                this.c_operation_id = this.operation_id
                this.c_instrument_id = this.instrument_id
                this.c_op_type = this.op_type
            }
                            
            this.operation = await this.$store.state.$pouch.get('operations', this.c_operation_id)
            this.instrument =  await this.$store.state.$pouch.get('registry',  this.c_instrument_id)
            this.client =  await this.$store.state.$pouch.get('registry',  this.operation.client_id)
            this.location =  await this.$store.state.$pouch.get('registry',  this.operation.location_id)
            
            
            if (!report_exists){
                // try to find report
                let res = await this.$store.state.$pouch.find('reports', {selector: 
                    {
                        operation_id: this.c_operation_id, 
                        instrument_id: this.c_instrument_id, 
                        op_type: this.c_op_type,
                        status: {'$nin': ['deleted', 'failed', 'revised']}
                    }
                })
                // console.log('DOCS', res.docs)
                if (res.docs.length==0) {
                    // new report
                    await this.initReport(this.client, this.location, this.instrument)
                } else {
                    this.report = res.docs[0]
                    switch(this.report.status) {
                        case 'new':
                            break;
                        case 'measuring':
                            // console.log(this.report.owner_id, this.$store.state.user._id)
                            if (this.report.owner_id != this.$store.state.user._id) {
                                // check permission
                                // block_edit = true
                            }
                            break
                        case 'completed':
                            // check permission
                            block_edit= true
                            break
                        case 'deleted':
                            // check permission
                            break
                        
                        default:
                            block_edit= true
                    }
                }
            } 
            this.initMeasure()
            let ops_rep = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'key', ['operation', this.operation._id], false)
            // console.log('OPS rep', ops_rep)
            this.ops_report = ops_rep.filter(rep => {
                return ['new', 'measuring'].includes(rep.value.status) && rep.id != this.report._id && rep.value.owner_id == this.$store.state.user._id// filter to see if there is my op_type 
            });
            let old_reps = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'all_keys', [this.c_instrument_id, ['op_type', this.report.op_type]], false)
            this.old_list = old_reps.filter(rep => {
                return ['ready', 'ready_failed'].includes(rep.value.status)
            })
            await this.searchMasters()
            this.setPrimaries()
            if (block_edit) {
                this.show_alert = true
            } else {
                this.show_measures()
            }
            this.validateNew(this.report)
            this.debouncedComplete()
            this.p_loading = false
            this.$nextTick(()=>{
                let self = this
                // console.log(self.$refs) // Shows the mapRef object reference
                self.$refs.reportRegistry.validate() // returns undefined ???
            });
        },
        toggleDebounce(){
            this.automaticSave = !this.automaticSave
        },
        generateReportCode(){
            console.log("$$ to be implemented! $$")
        },
        buildData(){
            return this.instrument.platforms[this.p_idx];
        },
        async initReport(client, location, instrument) {
            let pl_reports = Object.assign({}, ...instrument.platforms.map(s => ({[s.id]: null})))
            let Report = getModel("Report");
            let date = (new Date()).getTime()
            // console.log("instrument",instrument)
            // console.log("location",location)
            // console.log("client",client)
            // console.log("op_id", this.operation_id)
            // console.log("user", this.$store.state.user._id)
            // console.log("op_date", this.op_date)
            this.report = Report({
                instrument_id: instrument._id,
                client_id: client._id,
                location_id: location._id,
                operation_id: this.operation_id,
                department_id: instrument.department_id,
                op_type: this.c_op_type,
                ext_data: {
                    client: client,
                    instrument: instrument,
                    location: location
                },
                pl_reports: pl_reports,
                created_by: this.$store.state.user._id,
                owner_id: this.$store.state.user._id,
                //org_id: this.$store.state.user.org_id,
                updated: date,
                report_date: parseInt(this.op_date)
            })
            if (this.$store.state.config.enable_report_code_gen) {
                let report_code = {
                    'leg': 'VP',
                    'iso': 'ISO',
                    'iso_simple': 'ISO_SIMP',
                    'lat': 'LAT'
                }
                this.report.code = "tmp:"+ this.$store.state.config.report_year+'-'+this.$store.state.user.code+'-'+report_code[this.report.op_type]+'-'+(new Date()).getTime()
            }
            
            //await this.saveReport()
            // console.log('§§§§§§§§ report', this.report)
        },
        async cloneReport(){
            if(this.old_to_clone != null){
                this.report.pl_reports = _.cloneDeep(this.old_to_clone.pl_reports)
            }
            this.initMeasure()

            await this.searchMasters()
            /*for (let key of Object.keys(this.platforms)){
                this.platforms[key].measure = true
                this.$set(
                        this.pl_master_primaries, 
                        key, 
                        {'primaries': _.cloneDeep(this.report.pl_reports[key].primaries), 'chosen_tolerance': _.cloneDeep(this.report.pl_reports[key].chosen_tolerance)}
                    )
            }*/
            this.setPrimaries()
            this.show_measures()
        },
        getStatusIcon(obj, data) {
            if (!data){
                data = null
            }
            return getObjStatus(this.$store.state.config.threshold, obj, data)
        },
        checkExtObj(){
            // check client, LOCATION AND instrument external compatibility
            // and revìwrite external obj at the last version
            this.report.ext_data.client =  this.client
            if (this.report.ext_data.instrument && this.report.ext_data.instrument._rev != this.instrument._rev) {
                this.change_check.instrument = true
            } else {
                this.change_check.instrument = false
            } 
                
            this.report.ext_data.instrument =  this.instrument
            this.report.ext_data.location =  this.location
        },
        async initPlatformsData() {
            for( let platform of this.instrument.platforms) {
                if (platform.family) {
                    for(let range of platform.ranges){
                        this.calculateDivNr(range)
                    }
                    this.$set(this.platforms[platform.id], 'i_data', platform)
                    this.instrument_changed_alert[platform.id] = (!this.report.pl_reports[platform.id] || this.report.pl_reports[platform.id].primaries==undefined || (this.report.pl_reports[platform.id].primaries && this.report.pl_reports[platform.id].primaries.length == 0)) ? false : this.change_check.instrument
                    // this.instrument_changed_alert[platform.id] = this.change_check.instrument
                }
            }
            this.setTolerances()
        },
        initMeasure(){
            // console.log("$$ init measure report", this.report)
            for (let p_id of Object.keys(this.report.pl_reports)) {
                this.platforms[p_id] = { measure: false , panels: [], primaries:[]}
                // console.log("$$ debug: report ", this.report.pl_reports[p_id])
                if (this.report.pl_reports[p_id] && this.report.pl_reports[p_id]._id) {
                    this.platforms[p_id].master = _.cloneDeep(this.report.pl_reports[p_id])
                    this.platforms[p_id].master.blocks = _.cloneDeep(this.report.pl_reports[p_id].original_blocks)
                    delete this.platforms[p_id].master.original_blocks
                    this.platforms[p_id].measure = true
                
                    this.$set(
                        this.pl_master_primaries, 
                        p_id, 
                        {'primaries': _.cloneDeep(this.report.pl_reports[p_id].primaries), 'chosen_tolerance': _.cloneDeep(this.report.pl_reports[p_id].chosen_tolerance)}
                    )

                } else {
                    this.$set(
                        this.pl_master_primaries, 
                        p_id, 
                        {'primaries': null, 'chosen_tolerance': null}
                    )
                }
            }
            // console.log("PLATFORM OBJ", this.enable_measure, this.platforms)
            this.checkExtObj()
            this.initPlatformsData()
            //this.setPrimaries()
            for (let p_id of Object.keys(this.report.pl_reports)) {
                if (this.report.pl_reports[p_id]) {
                    this.changePlatformMaster(p_id, this.platforms[p_id].master)
                }
            }
        },
        setTolerances() {
            for (let p_id of Object.keys(this.pl_master_primaries)) {
                if (this.pl_master_primaries[p_id] && this.pl_master_primaries[p_id].chosen_tolerance) {
                    let idx = _.findIndex(this.platforms[p_id].i_data.tolerance, this.pl_master_primaries[p_id].chosen_tolerance)
                    if (idx != -1) {
                        this.pl_master_primaries[p_id].chosen_tolerance = this.platforms[p_id].i_data.tolerance[idx]
                    }
                }
            }
        },
        setPrimaries() {
            for (let p_id of Object.keys(this.pl_master_primaries)) {
                let tmp_primaries= []
                let o_primaries = this.pl_master_primaries[p_id].primaries
                if (this.pl_master_primaries[p_id] && this.pl_master_primaries[p_id].primaries) {
                    // console.log("PRIMARIES",this.platforms[p_id].primaries)
                    tmp_primaries = _.filter(this.platforms[p_id].primaries, function(primary) {
                        // console.log('+++++', primary)
                        let idx = _.findIndex(o_primaries, function(o_prim) {
                            return o_prim._id == primary._id
                        })
                        // console.log('+++++', idx)
                        if (idx != -1) {
                            return primary
                        }    
                    })
                    
                }
                this.pl_master_primaries[p_id].primaries = tmp_primaries 
                // console.log("*******", this.pl_master_primaries[p_id].primaries)
            }
             
        },
        getFormattedDate(ts) {
            return formatDatefromTS(ts)
        },
        editInstrument() {
            //this.$router.push({path: '/instrument/edit'})
            this.data = {
                instrument_id: this.instrument._id,
                location_id: this.location._id,
                lock_client: true
            }
            // if (this.primary) {
            //     this.data.owner_lock = false 
            // }                            // A CHE SERVE QUESTO?
            if(this.instrument.primary){
                this.data.primary = true
                this.data.org_id = this.instrument.org_id
                this.data.owner_lock = true
            }
            this.$refs.instrumentEdit.openDialog(this.data);
            
        },
        async changePlatformMaster(p_id, master, resetAll=true) {
            let m_change = {reset: resetAll, alert: false, mismatch: null}
            if (this.platforms[p_id].i_data.category) {
                let category = await this.$store.state.$pouch.get('masters', this.platforms[p_id].i_data.category)
                let mismatch = checkMasterCategoryMatch(master, category)
                if (mismatch.length > 0) {
                    m_change.alert = true
                    m_change.mismatch = mismatch
                    
                }
            }
            this.$set(this.pl_master_change, p_id, m_change)
            this.platforms[p_id].measure = true
            this.enable_measure = this.checkEnableMeasure()
        },
        async initMeasurePlat(p_id, resetAll=true){
            //platform.master = this.report.master
            this.ts_updated_block = Date.now()
            this.old_to_clone = null
            this.platforms[p_id].measure = true
            
            // console.log("$$ debug: master", this.platforms[p_id].master)
            if (resetAll) {
                this.$set(this.report.pl_reports, p_id, _.cloneDeep(this.platforms[p_id].master)) 
                //this.report.pl_reports[p_id] = _.cloneDeep(this.platforms[p_id].master)
                this.$set(this.report.pl_reports[p_id], 'primariesConfirmed', false)
                this.$set(this.report.pl_reports[p_id], 'keepMeasures', false)
            }
            this.$set(this.report.pl_reports[p_id], 'original_blocks', _.cloneDeep(this.report.pl_reports[p_id].blocks))
            let filtered = this.report.pl_reports[p_id].blocks.filter((block) => {
                return block.block_type == "general" || block.block_type == "dynamic"
            })
            this.report.other_info.module = this.platforms[p_id].master.master_module
            if(this.report.op_type == "leg"){
                this.report.other_info.module_cert = this.platforms[p_id].master.master_mod_cert
            }
            let assigned_procedure = this.platforms[p_id].master.assigned_procedure
            if(this.platforms[p_id].master.assigned_procedure){
                let res = await this.$store.state.$pouch.get('registry', assigned_procedure)
                if(res){
                    this.$set(this.report.other_info, 'procedure_code', res.name)
                }
            }
            this.$set(this.report.pl_reports[p_id], 'blocks', filtered)
            this.buildCommonData(this.report.pl_reports[p_id])
            this.show_measures()
        },
        buildCommonData(platform){
            let common_data = {
                hello: 'world'
            }
            for(let block of platform.blocks){
                if(!common_data[block.name]){
                    common_data[block.name] = {}
                }
                common_data[block.name][block._id] = {value: "0"}
            }
            platform.common_data = _.cloneDeep(common_data)
        },
        close() {
            this.show_alert = false
            this.show_close_alert = false
            this.show_error = false
            if (this.back){
                this.$router.push({path: this.back})
            } else {
                this.$router.push({path: '/reports/list'})
            }
        },
        changeReport() {
            this.change_report.show = true
        },
        autogenerateCode() {
            return this.$store.state.config.enable_report_code_gen
        },
        async goToReport() {
            this.change_report.show = false
            await this.saveReport()
            // console.log('SELECTED REPORT', this.change_report.selected_report)
            this.$router.push({path: "/reports/edit", query: {"report_id": this.change_report.selected_report, "back": this.back}})
        },
        async getPrimariesByFamily(p_family){
            // to be replaced with searchDesign
            let org_id = this.$store.state.user.org_id
            if (this.report.owner_id != this.$store.state.user._id && isAdmin(this.$store.state.user.roles)){
                org_id = this.$store.state.users[this.report.owner_id].org_id
            }
            let allowed_primaries = i_families[p_family].allowed_primaries
            let selector = {
                selector: {
                    doc_type: 'instrument',
                    primary: true,
                    used_by: org_id,
                    family: {'$in': allowed_primaries},
                    dismissed: false
                }
            }
            let res = await this.$store.state.$pouch.find("registry", selector)
            // console.log("$$$ PRIMARI TROVATI CON QUESTO SELECTOR", selector, res.docs)
            let currentDate = Date.now()
            return res.docs.filter(item => {
                return item.primary_data.active == true && item.primary_data.expire > currentDate
            })
        },
        async searchMasters(){
            // to be replaced with searchDesign
            for( let platform of this.instrument.platforms) {
                if (platform.family) {
                    let selector = {
                        selector: {
                            doc_type: "master",
                            family: platform.family,
                            op_type: this.c_op_type,
                            active: true
                        }
                    }
                    let res = await this.$store.state.$pouch.find('masters', selector)
                    let sortedMasters = _.sortBy(res.docs, [function(o) { return o.name.toUpperCase(); }])
                    this.$set(this.platforms[platform.id], 'masters', sortedMasters)
                    let primaries = await this.getPrimariesByFamily(platform.family)
                    // console.log("$$$ primari prima di comparison", primaries)
                    primaries = await this.filterEnabledComparison(primaries, platform.family)
                    // console.log("$$$ primari dopo comparison ", primaries)
                    let sortedPrimaries = _.sortBy(primaries, [function(o) { return o.name.toUpperCase(); }])
                    this.$set(this.platforms[platform.id], 'primaries', filterPrimaries(this.platforms[platform.id], sortedPrimaries, this.report.op_type, this.report.operation_id).map(
                        element => {
                            if(!element.name) {
                                element.name = `${element.family} : ${element.serno} - ${element.manufacturer} - cert. nr. ${element.primary_data.certificate_nr} del ${formatDatefromTS(element.primary_data.emission)}`
                            }
                            return element
                        }
                    ))
                }
            }
            let ready_rep = this.old_list.filter(rep => {
                return rep.value.status == 'ready'
            })
            let ids = _.sortBy(_.map(ready_rep, 'id'), 'id')
            let old = await this.$store.state.$pouch.allDocs('reports',{keys: ids})
            old = _.map(old.rows, 'doc')
            this.old_reports = old.filter((elem) => {
                return this.checkOldReport(elem)
            })
            this.validatePrimaries()
        },
        async filterEnabledComparison(primaries, family){
            if (family != "bilancia awi X" && family != "bilancia awi Y"){
                // console.log("$$ debug uscita", family)
                return primaries
            }
            let operation = await this.$store.state.$pouch.get("operations", this.report.operation_id)
            let comparisons = primaries.filter(item => {
                if(operation.comparator_ids.indexOf(item._id) > -1){
                    return true
                } else {
                    return false
                }
            })
            let primariesToReturn = primaries.filter(a => {
                if(a.family == "pesiera"){
                    return true
                } else {
                    return false
                }
            })
            for(let comp of comparisons){
                let res = await this.$store.state.$pouch.find("reports", {selector: {
                    instrument_id: comp._id,
                    operation_id: this.report.operation_id,
                    status: {"$in": ['completed', 'ready']}
                }})
                if(res.docs.length > 0){
                    primariesToReturn.unshift(comp)
                }
            }
            return primariesToReturn
        },
        openOldReport(report_id) {
            this.show_old_report.selected_report = report_id
            this.show_old_report.dialog = true
        },
        checkOldReport(item){
            // if(item.ext_data.instrument._rev != this.report.ext_data.instrument._rev){
            //     return false
            // }
            if(!this.comparePlatforms(item.ext_data.instrument.platforms, this.report.ext_data.instrument.platforms)){
                return false
            }
            for(let key of Object.keys(item.pl_reports)){
                let plat = this.platforms[key]
                if(plat){
                    let old_plat = item.pl_reports[key]
                    for(let master of plat.masters){
                        if(master._id == old_plat._id){
                            if(master.master_rev != old_plat.master_rev){
                                return false
                            }
                        }
                    }
                } else {
                    return false
                }
            }
            return true
        },
        comparePlatforms(oldPlats, newPlats){
            // console.log('length', oldPlats.length != newPlats.length)
            if(oldPlats.length != newPlats.length){
                return false
            }
            for(let i=0;i<oldPlats.length;i++){
                let oldOne = oldPlats[i]
                let newOne = newPlats[i]
                // console.log('old plat', oldOne, 'new plat', newOne)
                if(oldOne.uom != newOne.uom || oldOne.ranges.length != newOne.ranges.length || oldOne.instrument_class != newOne.instrument_class){
                    return false
                }
                for(let k=0; k<oldOne.ranges.length;k++){
                    let oldRange = oldOne.ranges[k]
                    let newRange = newOne.ranges[k]
                    if(oldRange.min != newRange.min || oldRange.max != newRange.max || oldRange.e != newRange.e || oldRange.d != newRange.d){
                        return false
                    }
                }
            }
            return true
        },
        validatePrimaries(){
            // console.log("$$ DEBUG validate primaries started")
            for(let rep of this.old_reports){
                for(let plat_key of Object.keys(rep.pl_reports)){
                    let plat_new = this.platforms[plat_key]
                    if(plat_new){
                        let plat_old = rep.pl_reports[plat_key]
                        for(let primary of plat_old.primaries){
                            for(let primary_new of plat_new.primaries){
                                if (primary_new._id == primary._id){
                                    if(primary_new.primary_data && primary_new.primary_data.certificate_nr !== primary.primary_data.certificate_nr && rep.c_op_type === "iso"){
                                        console.log("$$ debug need to calculate!!!", primary._id)
                                        // primary = _.cloneDeep(primary_new)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },

        validateNew(report){
            // console.log("$$ debug validate primaries for current report")
            if(report.op_type == "iso" || report.op_type == "lat"){
                Object.keys(report.pl_reports).forEach(key => {
                    let plat_new = this.platforms[key]
                    let plat = report.pl_reports[key]
                    this.invalidPrimaries[key] = false
                    if(plat_new && plat && plat.primaries){
                        let newPrimaries = []
                        plat.primaries.forEach(primary => {
                            let new_primary = plat_new.primaries.find(item => {
                                return item._id == primary._id
                            })
                            if(new_primary){
                                if(primary.primary_data.certificate_nr !== new_primary.primary_data.certificate_nr){
                                    // console.log("$$ need to recalculate", primary.name)
                                    newPrimaries.push(new_primary)
                                    this.invalidPrimaries[key] = true
                                } else {
                                    // console.log("$$ all fine on", primary.name)
                                    newPrimaries.push(primary)
                                }
                            }
                        })
                        report.pl_reports[key].primaries = newPrimaries
                    }
                })
            }
            
        },

        calculateDivNr(range){
            if(range.div_nr !== undefined || range.div_nr === 0){
                let min_div = 0
                switch(this.report.op_type){
                    case "leg": min_div = range.e; break
                    case "iso": min_div = range.d; break
                    case "iso_simple": range.e ? min_div = range.e : min_div = range.d; break
                    // case "iso_simple": min_div = range.d; break
                    case "lat": min_div = range.d; break
                    default: min_div = range.d
                }
                if(min_div && Big(min_div).gt(0)){
                    range.div_nr = Big(range.max).div(min_div).toString()
                }
            }
        },
        async updateBlockMeasure(data) {
            // console.log('UPDATEBLOCKMEASURE', data.p_id, this.report.pl_reports)
            this.report.pl_reports[data.p_id].blocks[data.b_index].measures = _.cloneDeep(data.measures)
            this.report.pl_reports[data.p_id].blocks[data.b_index].common_data = _.cloneDeep(data.common_data)
            // console.log("AUTOMATIC SAVE", this.automaticSave)
            this.debouncedComplete()
            
            if (this.automaticSave) {
                await this.debouncedSave()
            }
        },
        async savePlatformCommon(data) {
            // console.log('UPDATEPLATOFORMCOMMON', data.p_id, this.data)
            if (this.report.pl_reports[data.p_id].common==undefined) {
                this.report.pl_reports[data.p_id].common = {}
            }
            if (this.report.pl_reports[data.p_id].common[data.block_name] ==undefined) {
                this.report.pl_reports[data.p_id].common[data.block_name] = {}
            }
            this.report.pl_reports[data.p_id].common[data.block_name][data.key] = data.val
        },
        closeWithAlert(status) {
            this.show_close_alert = true
            this.closing_status = status
        }, 
        async saveExit(status) {
            // console.log('SAVE EXIT', status)
            this.save_error = false
            try {
                let res = await this.changeStatus(status)
                if (res) {
                    if(status == "completed" || status == "completed_failed" || status == "failed"){
                        await this.checkOpAndClose()
                    }
                    this.$root.$emit('remote_operation_update', {type: 'report', r_id: this.report_id, status:status })
                    this.close()
                } else {
                    // alert popup
                }
            } catch(error) {
                this.save_error = true
                console.log('error', error)
            }
        },

        async checkOpAndClose(){
            try {
                let sel = {
                    operation_id: this.report.operation_id,
                    status: {$nin: ['new','measuring','deleted']}
                }
                let res = await this.$store.state.$pouch.find('reports', {selector:sel, fields:['status']})
                let instr_set =  new Set(this.operation.instrument_ids)
                if (res.docs.length >= instr_set.size){
                    let op = await this.$store.state.$pouch.get('operations', this.report.operation_id)
                    op.status = "closed"
                    await this.$store.state.$pouch.post("operations", op)
                } else {
                    console.log("$$ intervento ancora non concluso")
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        
        async saveReport(){
            console.log('SAVING report');
            if (this.$refs.custom_data) {
                this.report.custom_data = _.cloneDeep(this.$refs.custom_data.getData())
            }
            this.report.updated_by = this.$store.state.user._id
            this.report.updated = (new Date()).getTime()
            this.report.org_id = this.computed_org
            
            let r_res = await this.$store.state.$pouch.put('reports', this.report)
            if (r_res && r_res.ok) {
                this.report._rev = r_res.rev
            }
            // console.log('SAVED report', this.report);
        },
        checkEnableMeasure(){
            if (!this.report.ext_data.instrument.complete[this.report.op_type]) {
                    return false
            }
            for (let pl of Object.values(this.platforms)){
                if (!pl.measure) {
                    return false
                }
            }
            return true
        },
        async show_measures() {
            this.enable_measure = this.checkEnableMeasure()
            if (!this.enable_measure) {
                return
            }
            this.change_master = false
            if (this.report.status == "new") {
                let res = await this.changeStatus('measuring')
                if (!res) {
                    console.log("$$ failed to change status")
                    // alert popup
                }
            }
            // console.log('change master false')
        },
        async updateMaster(){
            for (let p_id of Object.keys(this.report.pl_reports)) {
                this.platforms[p_id].master = this.new_masters[p_id]
                this.initMeasurePlat(p_id, this.pl_master_change[p_id].reset)
            }
            this.pl_master_change = {}
            this.new_masters = {}
            this.change_master = false
        },
        cancelUpdateMaster() {
            this.new_masters = {}
            this.pl_master_change = {}
            this.change_master = false
        },
        changeMaster() {
            this.change_master = true
            // console.log('change master true')
        },
        async updateInstrument(instr_id){
            // console.log('UPDATE INSTRUMENT', this.report)
            if (instr_id == this.report.instrument_id) {
                this.instrument = await this.$store.state.$pouch.get('registry', this.report.instrument_id)
                this.report.ext_data.instrument = this.instrument
                this.change_check.instrument = true
                this.initPlatformsData()
                await this.searchMasters()
                this.resetChosenTolerances()
            } else {
                this.show_error = true
                console.log("ERROR - $$ to be implemented")
            }
            console.log("$$ to be implemented")      
        },
        async changeStatus(newStatus) {
            // console.log('change status', newStatus)
            if (rStatusCanChange(this.report.op_type, this.report.status, newStatus)) {
                this.report.status = newStatus
                await this.saveReport()
                return true
            } else {
                return false
            }
        },

        resetChosenTolerances(){
            for(let p_id of Object.keys(this.report.pl_reports)){
                //console.log(p_id, this.report.pl_reports[p_id])
                if (this.report.pl_reports[p_id]) {
                    this.report.pl_reports[p_id].chosen_tolerance = null
                }
                if(this.pl_master_primaries[p_id]) {
                    this.pl_master_primaries[p_id].chosen_tolerance = null
                }   
            }
        },

        openChangePrimariesDialog(plat_id){
            this.change_primaries_confirm.plat_id = plat_id
            this.change_primaries_confirm.dialog = true
        },

        onChangePrimariesConfirm(choice) {
            let plat_id = this.change_primaries_confirm.plat_id
            switch(choice){
                case 'cancel':
                    break
                case "delete":
                    this.report.pl_reports[plat_id].primaries = _.cloneDeep(this.pl_master_primaries[plat_id].primaries)
                    this.report.pl_reports[plat_id].chosen_tolerance = _.cloneDeep(this.pl_master_primaries[plat_id].chosen_tolerance)
                    this.resetMeasures(plat_id)
                    this.debouncedComplete()
                break;
                case "mantain":
                    this.report.pl_reports[plat_id].primaries = _.cloneDeep(this.pl_master_primaries[plat_id].primaries)
                    this.report.pl_reports[plat_id].chosen_tolerance = _.cloneDeep(this.pl_master_primaries[plat_id].chosen_tolerance)
                    
                    this.$set(this.report.pl_reports[plat_id],'primariesConfirmed', true)
                    break;
            }
            this.closeDialog()
        },
        openResetMeasureDialog(plat_id){
            this.reset_measure_confirm.plat_id = plat_id
            this.reset_measure_confirm.dialog = true
        },
        onResetMeasureConfirm(choice) {
            let plat_id = this.reset_measure_confirm.plat_id
            switch(choice){
                case "delete":
                    this.resetMeasures(plat_id)
                    this.debouncedComplete()
                break;
            }
            this.closeDialog()
        },
        onUpdatedInstrumentConfirm(){
            this.closeDialog()
        },
        closeDialog(){
            this.reset_measure_confirm.dialog = false
            this.updated_instrument_confirm.dialog = false
            this.change_primaries_confirm.dialog = false
        },
        resetMeasures(plat_id) {
            for (let block of this.report.pl_reports[plat_id].blocks) {
                this.$set(block, 'measures', null);
            }
            this.initMeasurePlat(plat_id, false)
            this.instrument_changed_alert[plat_id] = false
            this.$set(this.report.pl_reports[plat_id],'primariesConfirmed', true)
        },
        catchPretestResult(result, platform){
            // console.log("got pretest result", result, platform)
            if(result != this.report.pl_reports[platform].pretest_result){
                let blocks = []
                for(let block of this.report.pl_reports[platform].original_blocks){
                    if(block.block_type == "general"){
                        blocks.push(block)
                    }
                }
                let other_blocks = []
                if(result) {
                    // console.log("carico statici da", this.platforms[platform].master.blocks)
                    other_blocks = _.cloneDeep(this.platforms[platform].master.blocks).filter((block) => {
                        return block.block_type == "static"
                    })
                } else {
                    // console.log("carico dinamici da ", this.platforms[platform].master)
                    other_blocks = _.cloneDeep(this.platforms[platform].master.blocks).filter((block) => {
                        return block.block_type == "dynamic"
                    })
                }
                // console.log("other blocks", other_blocks)
                blocks.push(...other_blocks)
                this.report.pl_reports[platform].blocks = blocks
                this.report.pl_reports[platform].pretest_result = result
            } else {
                // console.log("pretest still on same result, not changing blocks")
            }
        },
        confirmPrimaries(p_id){
            //if(!this.report.pl_reports[p_id].keepMeasures){
                //console.log("keep measures false, asking for reset", this.report.pl_reports[p_id])
                if (!this.report.pl_reports[p_id].primaries || this.report.pl_reports[p_id].primaries.length == 0) {
                    this.report.pl_reports[p_id].primaries = _.cloneDeep(this.pl_master_primaries[p_id].primaries)
                    this.report.pl_reports[p_id].chosen_tolerance = _.cloneDeep(this.pl_master_primaries[p_id].chosen_tolerance)
                    this.resetMeasures(p_id)
                    this.debouncedSave()
                } else {
                    this.openChangePrimariesDialog(p_id)
                }
            //}
            //this.$set(this.report.pl_reports[p_id],'primariesConfirmed', true)
        },
        primariesCancel(p_id) {
            let idx = _.findIndex(this.platforms[p_id].i_data.tolerance, this.report.pl_reports[p_id].chosen_tolerance)
            
            this.$set(this.pl_master_primaries, p_id, {'primaries': _.cloneDeep(this.report.pl_reports[p_id].primaries), 'chosen_tolerance': this.platforms[p_id].i_data.tolerance[idx]})
            
            this.$set(this.report.pl_reports[p_id],'primariesConfirmed', true)
        },
        primaryChange(p_id){
            // this.$set(this.pl_master_primaries[p_id], 'primaries', _.cloneDeep(this.report.pl_reports[p_id].primaries))
            // this.$set(this.pl_master_primaries[p_id], 'chosen_tolerance', _.cloneDeep(this.report.pl_reports[p_id].chosen_tolerance))
            this.$set(this.report.pl_reports[p_id],'primariesConfirmed', false)
        },
        changePrimaryComplete(primary){
            if(primary.primary_data.complete != undefined || primary.primary_data.complete != null){
                this.$set(primary.primary_data, 'complete', primary.primary_data.complete)
            } else {
                this.$set(primary.primary_data, 'complete', true)
            }
        },
        isDateEditable() {
            if(this.report.history.length > 0 ){
                return true
            } else {
                return isAdmin(this.$store.state.user.roles)
            }
        }

    }

}
</script>

<style>
.basic_card .v-expansion-panel__header {
    padding: 0px;
    margin:0px;
    min-height: 0px !important;
}

</style>
